import React from 'react';
import { personalData } from '../data';

const Services = () => {
  return (
    <section id="services" className="section">
      <h2 className="section-title">Consultancy Services</h2>
      <div className="section-content">
        <ul className="services-list">
          {personalData.services.map((service, index) => {
            const colonIndex = service.indexOf(':');
            if (colonIndex !== -1) {
              const title = service.substring(0, colonIndex);
              const description = service.substring(colonIndex + 1);
              return (
                <li key={index}>
                  <strong>{title}:</strong>{description}
                </li>
              );
            }
            return <li key={index}>{service}</li>;
          })}
        </ul>
      </div>
    </section>
  );
};

export default Services;
